// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ConfiguredItemForm from '../../containers/sources/ConfiguredItemForm';
import CustomConfiguredItemBtn from './CustomConfiguredItemBtn';
import SourcesStackItemHeader from './SourcesStackItemHeader';
import ConfiguredItemColumnHeader from './ConfiguredItemColumnHeader';
import { getVisibleConfiguredItemFormFields } from './configuredItemFormFields';
// css
import '../../styles/components/sources/SourcesStackItem.scss';


class SourcesStackItem extends Component {

  buildCustomConfigurationItem(id) {
    return {
      'description': 'custom items... etc',
      'defaultLogSize': 0,
      'example': null,
      'order': 1,
      'deleted': false,
      'id': id,
      'overlap': null,
      'correlationIds': []
    };
  }

  getVisibleConfiguredItems() {
    const {
      subarea,
      configuredItems
    } = this.props;

    return configuredItems
    .filter(item => item.subarea === subarea.id)
    .sort((a, b) => a.order - b.order);
  }

  hasConfiguredItems() {
    return !! this.props.configuredItems;
  }

  renderConfiguredItemForms() {
    const {
      dsaConfiguredItems,
      updateConfiguredItem,
      changeConfiguredItem,
      makeOpenContributedCorrelationModal,
      closeContributedCorrelationModal,
      isContributedCorrelationModalOpen,
      canEditEstimatedLogSize,
      canEditPercentItemsIndexed,
      canEditPercentDataSourcesIndexed,
      canViewTotalIndexed,
      hasDSASecurityExtension
    } = this.props;

    if (this.hasConfiguredItems()) {
      return this.getVisibleConfiguredItems().map(item => {
        const answer = dsaConfiguredItems
        .find(answer => answer.configureditem === item.id);

        return (
          <ConfiguredItemForm
            configuredItem={item}
            dsaConfiguredItem={answer}
            updateConfiguredItem={updateConfiguredItem}
            changeConfiguredItem={changeConfiguredItem}
            openContributedCorrelationModal={makeOpenContributedCorrelationModal(item)}
            closeContributedCorrelationModal={closeContributedCorrelationModal}
            contributedCorrelationModalOpen={isContributedCorrelationModalOpen(item)}
            key={item.id}
            canEditEstimatedLogSize={canEditEstimatedLogSize}
            canEditPercentItemsIndexed={canEditPercentItemsIndexed}
            canEditPercentDataSourcesIndexed={canEditPercentDataSourcesIndexed}
            canViewTotalIndexed={canViewTotalIndexed}
            hasDSASecurityExtension={hasDSASecurityExtension}
          />
        );
      });
    }
  }

  renderCustomConfiguredItems() {
    const {
      subarea,
      dsaConfiguredItems,
      updateConfiguredItem,
      changeConfiguredItem,
      canEditEstimatedLogSize,
      canEditPercentItemsIndexed,
      canEditPercentDataSourcesIndexed,
      canViewTotalIndexed,
      hasDSASecurityExtension
    } = this.props;

    return (
      dsaConfiguredItems &&
      dsaConfiguredItems
      .filter(answer => answer.configureditem === null && answer.subarea === subarea.id)
      .map(answer => {
        return (
          <ConfiguredItemForm
            configuredItem={this.buildCustomConfigurationItem(answer.id)}
            dsaConfiguredItem={answer}
            updateConfiguredItem={updateConfiguredItem}
            changeConfiguredItem={changeConfiguredItem}
            key={answer.id}
            canEditEstimatedLogSize={canEditEstimatedLogSize}
            canEditPercentItemsIndexed={canEditPercentItemsIndexed}
            canEditPercentDataSourcesIndexed={canEditPercentDataSourcesIndexed}
            canViewTotalIndexed={canViewTotalIndexed}
            hasDSASecurityExtension={hasDSASecurityExtension}
          />
        );
      })
    );
  }

  renderConfiguredItemColumnHeaders() {
    const fields = getVisibleConfiguredItemFormFields(this.props);

    return (
      <div className='sources-stack-item__configured-item-column-headers'>
        {fields.map(({ label, tooltip, flex }, index) => (
          <ConfiguredItemColumnHeader
            label={label}
            tooltip={tooltip}
            flex={flex}
            key={index}
          />
        ))}
      </div>
    );
  }

  render() {
    const {
      dsa,
      dsaConfiguredItems,
      subarea,
      progress,
      areaStats,
      stats,
      active,
      toggleSubArea,
      createCustomConfiguredItem,
      canViewTotalIndexed
    } = this.props;

    return (
      <div className={classNames('accordion-container', 'sources-stack-item', {active: active})}>
        <div className='accordion-header' onClick={() => toggleSubArea(subarea.id)}>
          <SourcesStackItemHeader
            active={active}
            title={subarea.title}
            configuredItemsCount={stats.configuredItems}
            itemsCompleteCount={progress.current}
            totalItemsCount={progress.total}
            totalDataRequired={areaStats.dataRequired}
            dataIndexed={stats.dataIndexed}
            dataRequired={stats.dataRequired}
            percentIndexed={stats.percentIndexed}
            canViewTotalIndexed={canViewTotalIndexed}
            ciscoDataPerDay={stats.ciscoDataPerDay}
            nonCiscoDataPerDay={stats.nonCiscoDataPerDay}
            ciscoDataIndexed={stats.ciscoDataIndexed}
            nonCiscoDataIndexed={stats.nonCiscoDataIndexed}
          />
        </div>
        <div className='accordion-pane'>
          {this.renderConfiguredItemColumnHeaders()}
          {this.renderConfiguredItemForms()}
          {this.renderCustomConfiguredItems()}
          <CustomConfiguredItemBtn
            dsa={dsa}
            subarea={subarea}
            createCustomConfiguredItem={createCustomConfiguredItem}
            numCustomItems={dsaConfiguredItems.filter(answer => answer.configureditem === null && answer.subarea === subarea.id).length}
          />
        </div>
      </div>
    );
  }
}

SourcesStackItem.propTypes = {
  dsa: PropTypes.object,
  subarea: PropTypes.object.isRequired,
  configuredItems: PropTypes.array,
  dsaConfiguredItems: PropTypes.array,
  active: PropTypes.bool,
  progress: PropTypes.object,
  areaStats: PropTypes.object,
  stats: PropTypes.object,
  toggleSubArea: PropTypes.func,
  updateConfiguredItem: PropTypes.func,
  changeConfiguredItem: PropTypes.func,
  createCustomConfiguredItem: PropTypes.func,
  makeOpenContributedCorrelationModal: PropTypes.func,
  closeContributedCorrelationModal: PropTypes.func,
  isContributedCorrelationModalOpen: PropTypes.func,
  canEditEstimatedLogSize: PropTypes.bool,
  canEditPercentItemsIndexed: PropTypes.bool,
  canEditPercentDataSourcesIndexed: PropTypes.bool,
  canViewTotalIndexed: PropTypes.bool,
  hasDSASecurityExtension: PropTypes.bool
};

export default SourcesStackItem;



// WEBPACK FOOTER //
// ./src/components/sources/SourcesStackItem.js